/* Divine Leaf premium product page: gallery, variants, prepaid price,
   quantity, Ajax add-to-cart + drawer, sticky mobile bar, delivery estimate,
   and product recommendations. No libraries. Re-inits in the Theme Editor. */
(function () {
  'use strict';
  if (window.__dlProductLoaded) return;
  window.__dlProductLoaded = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '₹{{amount}}';
    function delimit(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return parts.join(dec);
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    value = value.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* prepaid price rounded to whole rupees, matching the Liquid render */
  function prepaidOf(cents, pct) { return Math.round(cents * (100 - pct) / 10000) * 100; }

  /* ---------------- Gallery ---------------- */
  function initGallery(el) {
    var track = $('[data-dlp-track]', el);
    if (!track) return null;
    var slides = $$('[data-dlp-slide]', el);
    var thumbs = $$('[data-dlp-thumb]', el);
    var dots = $$('[data-dlp-dot]', el);
    var counter = $('[data-dlp-counter]', el);
    var index = 0;
    function render(i) {
      index = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      slides.forEach(function (s, k) {
        if (k !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); }
      });
    }
    function go(i, instant) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: (reduce || instant) ? 'auto' : 'smooth' });
      render(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index && slides[i]) render(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(Math.min(index + 1, slides.length - 1));
      if (e.key === 'ArrowLeft') go(Math.max(index - 1, 0));
    });
    var zoomBtn = $('[data-dlp-zoom]', el);
    var box = $('[data-dlp-lightbox]', el);
    if (zoomBtn && box && typeof box.showModal === 'function') {
      var boxImg = $('img', box);
      zoomBtn.addEventListener('click', function () {
        var full = slides[index] && slides[index].getAttribute('data-full');
        if (!full) return;
        boxImg.src = full;
        boxImg.alt = slides[index].getAttribute('data-alt') || '';
        box.showModal();
      });
      $('button', box).addEventListener('click', function () { box.close(); });
      box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
    } else if (zoomBtn) { zoomBtn.hidden = true; }
    render(0);
    return {
      showMedia: function (mediaId) {
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].getAttribute('data-media-id') === String(mediaId)) { go(k); return; }
        }
      }
    };
  }

  /* ---------------- Drawer ---------------- */
  function initDrawer(drawer, cfg) {
    if (!drawer) return null;
    var lastFocus = null;
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('dlp-lock');
      setTimeout(function () { drawer.hidden = true; }, reduce ? 0 : 320);
      if (lastFocus) lastFocus.focus();
    }
    function open(cart, added) {
      lastFocus = document.activeElement;
      var body = $('[data-dlp-drawer-items]', drawer);
      var item = added || (cart.items && cart.items[0]);
      body.innerHTML = '';
      if (item) {
        var line = document.createElement('div');
        line.className = 'dlp-line';
        var img = document.createElement('img');
        img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        img.alt = '';
        img.width = 76; img.height = 76;
        var txt = document.createElement('div');
        var t = document.createElement('div'); t.className = 'dlp-line__title'; t.textContent = item.product_title;
        var m = document.createElement('div'); m.className = 'dlp-line__meta';
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title + ' · ' : '';
        m.textContent = variant + 'Qty ' + item.quantity + ' · ' + formatMoney(item.final_line_price, cfg.moneyFormat);
        txt.appendChild(t); txt.appendChild(m);
        line.appendChild(img); line.appendChild(txt);
        body.appendChild(line);
      }
      var offer = $('[data-dlp-drawer-offer]', drawer);
      if (offer) body.appendChild(offer);
      var prepaid = $('[data-dlp-drawer-prepaid]', drawer);
      if (prepaid && cfg.prepaidPct > 0) {
        prepaid.textContent = formatMoney(prepaidOf(cart.total_price, cfg.prepaidPct), cfg.moneyFormat);
      }
      $('[data-dlp-drawer-subtotal]', drawer).textContent = formatMoney(cart.total_price, cfg.moneyFormat);
      $('[data-dlp-drawer-count]', drawer).textContent = cart.item_count;
      drawer.hidden = false;
      void drawer.offsetWidth; /* commit the unhidden state so the slide-in transition runs */
      setTimeout(function () {
        drawer.classList.add('is-open');
        document.body.classList.add('dlp-lock');
        var c = $('[data-dlp-drawer-close]', drawer); if (c) c.focus();
      }, 10);
    }
    $$('[data-dlp-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = $$('a[href], button:not([disabled])', drawer).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    return { open: open };
  }

  function updateCartBubbles(count) {
    $$('.cart-link__bubble, [data-cart-count], .cart-count-bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
      if (b.hasAttribute('data-cart-count')) b.textContent = count;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: count } }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  /* ---------------- Main product ---------------- */
  function initProduct(el) {
    if (el.__dlp) return; el.__dlp = true;
    var cfgEl = $('[data-dlp-config]', el);
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var product = cfg.product;
    var form = document.getElementById(cfg.formId);
    var gallery = initGallery(el);
    var drawer = initDrawer(document.getElementById('DlpDrawer-' + cfg.sectionId), cfg);
    var idInput = form && form.querySelector('input[name="id"]');
    var atcButtons = $$('[data-dlp-atc]', document).filter(function (b) { return b.getAttribute('data-section') === cfg.sectionId; });
    var errorEl = $('[data-dlp-error]', el);

    function currentOptions() {
      return $$('[data-dlp-option]', el).map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      $$('[data-dlp-option]', el).forEach(function (fs, pos) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[pos] = input.value;
          var v = findVariant(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
        var c = fs.querySelector('input:checked');
        var lbl = fs.querySelector('[data-dlp-selected]');
        if (c && lbl) lbl.textContent = c.value;
      });
    }
    function setPrice(v) {
      $$('[data-dlp-price-now]').forEach(function (n) { n.textContent = formatMoney(v.price, cfg.moneyFormat); });
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-dlp-price-was]').forEach(function (n) { n.hidden = !onSale; if (onSale) n.textContent = formatMoney(v.compare_at_price, cfg.moneyFormat); });
      $$('[data-dlp-price-save]').forEach(function (n) { n.hidden = !onSale; if (onSale) n.textContent = cfg.saveLabel + ' ' + formatMoney(v.compare_at_price - v.price, cfg.moneyFormat); });
      if (cfg.prepaidPct > 0) {
        $$('[data-dlp-prepaid-price]').forEach(function (n) { n.textContent = formatMoney(prepaidOf(v.price, cfg.prepaidPct), cfg.moneyFormat); });
        $$('[data-dlp-prepaid-save]').forEach(function (n) { n.textContent = formatMoney(v.price - prepaidOf(v.price, cfg.prepaidPct), cfg.moneyFormat); });
      }
    }
    function setButtons(v) {
      atcButtons.forEach(function (b) {
        var label = b.querySelector('.dlp-atc__label');
        var text = !v ? cfg.strings.unavailable : (!v.available ? cfg.strings.soldOut : (b.getAttribute('data-label') || cfg.strings.add));
        b.disabled = !v || !v.available;
        if (label && label.hasAttribute('data-text')) { label.setAttribute('data-text', text); b.setAttribute('aria-label', text); }
        else if (label) label.textContent = text;
      });
    }
    function onOptionChange() {
      var opts = currentOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      setButtons(v);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      setPrice(v);
      if (v.featured_media && gallery) gallery.showMedia(v.featured_media.id);
      if (cfg.updateUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      el.dispatchEvent(new CustomEvent('dlp:variant', { bubbles: true, detail: { variant: v } }));
    }
    $$('[data-dlp-option] input', el).forEach(function (i) { i.addEventListener('change', onOptionChange); });
    if ($$('[data-dlp-option]', el).length) markAvailability(currentOptions());

    /* quantity */
    var qty = $('[data-dlp-qty]', el);
    if (qty) {
      var input = qty.querySelector('input');
      $$('button', qty).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
          input.value = Math.max(1, Math.min(99, n));
        });
      });
    }

    /* add to cart */
    if (form && cfg.cartAction === 'drawer' && drawer && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btns = atcButtons;
        btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        var added;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (item) {
            added = item.items ? item.items[0] : item;
            /* Open the drawer immediately after Shopify confirms the add.
               Refresh cart totals in the background so slow app/network calls
               do not block the customer's next step. */
            var optimistic = {
              items: item.items || [item],
              item_count: item.item_count || 1,
              total_price: item.final_line_price || item.line_price || 0
            };
            updateCartBubbles(optimistic.item_count);
            drawer.open(optimistic, added);
            fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                updateCartBubbles(cart.item_count);
                drawer.open(cart, added);
              })
              .catch(function () {});
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || cfg.strings.error; errorEl.hidden = false; }
          })
          .then(function () {
            btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
            var v = idInput ? product.variants.filter(function (x) { return String(x.id) === String(idInput.value); })[0] : null;
            setButtons(v || product.variants[0]);
          });
      });
    }

    /* sticky bar: show once the main button has scrolled above the viewport */
    var sticky = document.getElementById('DlpSticky-' + cfg.sectionId);
    var mainBtn = $('[data-dlp-atc-main]', el);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var footer = document.querySelector('footer, .site-footer');
      var pastBtn = false, footerIn = false;
      function update() { sticky.classList.toggle('is-visible', pastBtn && !footerIn); sticky.setAttribute('aria-hidden', (pastBtn && !footerIn) ? 'false' : 'true'); }
      new IntersectionObserver(function (es) { es.forEach(function (e) { pastBtn = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }); }).observe(mainBtn);
      if (footer) new IntersectionObserver(function (es) { es.forEach(function (e) { footerIn = e.isIntersecting; update(); }); }).observe(footer);
      var sBtn = sticky.querySelector('[data-dlp-atc]');
      /* Buy now reuses the main Buy it now button, so the store's checkout
         app (Zecpe) runs exactly as it does there. */
      if (sBtn && form) sticky.addEventListener('click', function (e) {
        if (!sBtn.contains(e.target)) return;
        e.preventDefault(); e.stopPropagation();
        if (sBtn.disabled) return;
        if (sBtn.getAttribute('data-action') === 'buy_now') {
          var mainBuy = el.querySelector('.shopify-payment-button__button');
          if (mainBuy && !mainBuy.disabled) { mainBuy.click(); return; }
        }
        if (sBtn.getAttribute('data-action') === 'buy_now' && window.fetch) {
          /* add this item, then go straight to checkout */
          sBtn.setAttribute('aria-busy', 'true'); sBtn.disabled = true;
          if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
            .then(function () { window.location.href = root + 'checkout'; })
            .catch(function (err) {
              sBtn.removeAttribute('aria-busy'); sBtn.disabled = false;
              if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || cfg.strings.error; errorEl.hidden = false; }
              form.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          return;
        }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      }, true);
    }

    /* read more → open the description accordion */
    $$('[data-dlp-readmore]', el).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (target && target.tagName === 'DETAILS') { e.preventDefault(); target.open = true; target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      });
    });

    /* delivery estimate */
    var dForm = $('[data-dlp-delivery]', el);
    if (dForm) {
      var out = $('[data-dlp-delivery-result]', el);
      var pin = dForm.querySelector('input');
      try { var saved = localStorage.getItem('dl-pincode'); if (saved) pin.value = saved; } catch (e) {}
      dForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = (pin.value || '').replace(/\D/g, '');
        if (!/^[1-9]\d{5}$/.test(code)) { out.textContent = cfg.strings.pinInvalid; out.hidden = false; pin.focus(); return; }
        try { localStorage.setItem('dl-pincode', code); } catch (e2) {}
        var d = cfg.delivery;
        var zones = d.zones || [];
        var zone = null;
        for (var zi = 0; zi < zones.length && !zone; zi++) {
          var pins = (zones[zi].pins || []).filter(function (x) { return x; });
          for (var pi = 0; pi < pins.length; pi++) { if (code.indexOf(pins[pi]) === 0) { zone = zones[zi]; break; } }
        }
        if (!zone) zone = zones.filter(function (z) { return z.name && !(z.pins || []).filter(function (x) { return x; }).length; })[0] || zones[zones.length - 1];
        if (!zone) return;
        /* India time; orders after the cut-off or on Sunday start from the next working day */
        var now = new Date();
        var ist = new Date(now.getTime() + (now.getTimezoneOffset() + 330) * 60000);
        var start = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate());
        var cut = (zone.days === 0 && d.sameDayCutoff) ? d.sameDayCutoff : d.cutoff;
        var late = ist.getHours() >= cut || ist.getDay() === 0;
        function nextWorking(date) { var r = new Date(date); do { r.setDate(r.getDate() + 1); } while (r.getDay() === 0); return r; }
        if (late) start = nextWorking(start);
        var arrive = new Date(start);
        for (var k = 0; k < zone.days; k++) arrive = nextWorking(arrive);
        var today = new Date(ist.getFullYear(), ist.getMonth(), ist.getDate());
        var diff = Math.round((arrive - today) / 86400000);
        var dateTxt = arrive.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
        var when = diff === 0 ? 'today, ' + dateTxt : (diff === 1 ? 'tomorrow, ' + dateTxt : 'by ' + dateTxt);
        out.innerHTML = '';
        var s = document.createElement('strong'); s.textContent = zone.name + ' · ' + zone.time + ' delivery';
        out.appendChild(s);
        out.appendChild(document.createElement('br'));
        out.appendChild(document.createTextNode('Get it ' + when + ' (' + code + ')'));
        if (zone.days === 0 && late && d.cutoffLabel) { out.appendChild(document.createElement('br')); out.appendChild(document.createTextNode(ist.getDay() === 0 ? 'Sunday orders arrive on the next working day.' : 'Ordered after ' + d.cutoffLabel + ', so it arrives the next working day.')); }
        if (d.extra) { out.appendChild(document.createElement('br')); out.appendChild(document.createTextNode(d.extra)); }
        out.hidden = false;
      });
    }
  }

  /* ---------------- Recommendations ---------------- */
  function initRecs(el) {
    if (el.__dlpRecs) return; el.__dlpRecs = true;
    var url = el.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-dlp-recs]');
      if (fresh && fresh.querySelector('.dl-card')) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* ---------------- Reviews skin ----------------
     AfterShip draws its product reviews in a shadow root at the end of the
     page. Move it into our reviews section and give it the Divine Leaf look. */
  var REVIEWS_CSS = ":host { display: block; font-family: var(--dl-sans, system-ui, sans-serif); color: #1C1C1C; }\n* { font-family: inherit !important; }\n[class*=\"_title--\"] { display: none !important; }\n.dlr-summary { background: #FFFDF8 !important; border: 1px solid #E2CFA6; border-radius: 22px; padding: 24px 20px !important; box-shadow: 0 14px 34px rgba(169, 125, 52, .12); margin-bottom: 18px !important; }\n.dlr-flat { background: transparent !important; padding-left: 0 !important; padding-right: 0 !important; border: 0 !important; box-shadow: none !important; }\n[class*=\"centerOverallRating\"] { justify-content: center; gap: 12px; margin-bottom: 14px !important; }\nlabel[class*=\"sort\"] { overflow: visible !important; width: auto !important; white-space: nowrap; margin-right: 6px; }\n[class*=\"currentRate\"] { font-family: var(--dl-serif, \"Cormorant Garamond\", Georgia, serif) !important; font-size: 64px !important; font-weight: 500 !important; line-height: 1 !important; color: #1C1C1C !important; }\n[class*=\"progressBar\"] { background: #F1E7D3 !important; border-radius: 999px !important; height: 6px !important; overflow: hidden; }\n[class*=\"progressBar\"] span { border-radius: 999px !important; background: linear-gradient(90deg, #D7B87F, #A97D34) !important; }\n[style*=\"255, 179, 3\"] { fill: #C9A45C !important; background-color: #C9A45C !important; color: #C9A45C !important; }\n[class*=\"theButton\"] { background: #1C1C1C !important; color: #F3E3BC !important; border: 1px solid #C9A45C !important; border-radius: 999px !important; min-height: 46px; padding: 0 26px !important; font-size: 12px !important; font-weight: 600 !important; letter-spacing: .18em; text-transform: uppercase; transition: transform .3s cubic-bezier(.2, .7, .2, 1), box-shadow .3s; }\n[class*=\"theButton\"]:hover { transform: translateY(-2px); box-shadow: 0 10px 22px rgba(28, 28, 28, .2); }\n[class*=\"filterSortContainer\"] { margin: 6px 0 14px !important; font-size: 13px; }\n[class*=\"solid-select-control\"] { border-radius: 999px !important; border-color: #E2CFA6 !important; background: #FFFDF8 !important; }\n[class*=\"cardContainer\"] { background: #FFFDF8 !important; border: 1px solid #EADDC2 !important; border-radius: 18px !important; padding: 18px 18px 16px !important; margin-bottom: 12px !important; box-shadow: 0 8px 22px rgba(28, 28, 28, .05); transition: transform .35s cubic-bezier(.2, .7, .2, 1), box-shadow .35s; }\n[class*=\"cardContainer\"]:hover { transform: translateY(-2px); box-shadow: 0 14px 30px rgba(169, 125, 52, .14); }\n[class*=\"cardContainer\"] > div:nth-child(2) > div:first-child { font-weight: 600; letter-spacing: .02em; }\n[class*=\"cardContainer\"] img { border-radius: 12px !important; }\n[class*=\"cardContainer\"] { font-size: 14px; line-height: 1.6; color: #3A3530; }\n[class*=\"readMore\"] { color: #8A6A2F !important; text-decoration: underline; text-underline-offset: 3px; }\n[class*=\"pagination\"] { margin-top: 18px !important; }\n[class*=\"pagination\"] [aria-current=\"true\"], [class*=\"pagination\"] [class*=\"active\"] { background: #1C1C1C !important; color: #F3E3BC !important; border-color: #1C1C1C !important; }\n";
  function initReviewsSkin() {
    var target = document.querySelector('.dlp-app-reviews');
    if (!target) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (++tries > 60) { clearInterval(timer); return; }
      var host = document.getElementById('am-reviews-carousel-shadow-container-production');
      var sr = host && host.shadowRoot;
      var summary = sr && sr.querySelector('[class*="centerOverallRating"]');
      if (!summary) return;
      clearInterval(timer);
      if (!sr.querySelector('style[data-dl-skin]')) {
        var s = document.createElement('style'); s.setAttribute('data-dl-skin', ''); s.textContent = REVIEWS_CSS; sr.appendChild(s);
      }
      if (host.parentElement !== target) target.appendChild(host);
      var p = summary.parentElement;
      if (p) p.classList.add('dlr-summary');
      while (p && p.parentElement) {
        p = p.parentElement;
        if (getComputedStyle(p).backgroundColor === 'rgb(255, 255, 255)') p.classList.add('dlr-flat');
      }
    }, 300);
  }

  function initAll(scope) {
    $$('[data-dlp-root]', scope).forEach(initProduct);
    $$('[data-dlp-recs][data-url]', scope).forEach(initRecs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  initReviewsSkin();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
